const BUFFER_STORAGE_KEY = 'fs_event_buffer';
const MAX_BUFFERED_EVENTS = 25;
const FIVE_MINUTES_MS = 300_000;

interface BufferedEvent {
  name: string;
  payload: Record<string, unknown>;
  capturedAt: number;
}

let buffer: BufferedEvent[] = loadFromStorage();
let ready = false;

function loadFromStorage(): BufferedEvent[] {
  try {
    const raw = sessionStorage.getItem(BUFFER_STORAGE_KEY);

    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function persistToStorage(): void {
  try {
    sessionStorage.setItem(BUFFER_STORAGE_KEY, JSON.stringify(buffer));
  } catch {
    // sessionStorage full or unavailable — in-memory buffer is still intact
  }
}

function clearStorage(): void {
  try {
    sessionStorage.removeItem(BUFFER_STORAGE_KEY);
  } catch {
    // no-op
  }
}

export function enqueueEvent(name: string, payload: Record<string, unknown>): void {
  if (ready) {
    window.FS?.event?.(name, payload);

    return;
  }

  if (buffer.length >= MAX_BUFFERED_EVENTS) {
    buffer.shift();
  }

  buffer.push({ name, payload, capturedAt: Date.now() });
  persistToStorage();
}

export function flushEventBuffer(): void {
  ready = true;
  const now = Date.now();

  for (const event of buffer) {
    if (now - event.capturedAt <= FIVE_MINUTES_MS) {
      window.FS?.event?.(event.name, event.payload);
    }
  }

  buffer = [];
  clearStorage();
}

export function discardEventBuffer(): void {
  buffer = [];
  clearStorage();
}

export function resetEventBuffer(): void {
  ready = false;
  buffer = [];
  clearStorage();
}
